module.exports = __webpack_public_path__ + "img/6.9f83f115.png";